module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.rewardOrderList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rewardList"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.createTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(item.rewardAmount) + "元")])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6999806a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/RewardList.vue
// module id = 447
// module chunks = 7